import {ngXUrls} from '../../../src/app/config/url.handling';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart} from '@angular/router';

export default [
  '$rootScope',
  '$localStorage',
  '$state',
  'AuthService',
  'AccountsService',
  '$transitions',
  'PermPermissionStore',
  'ipUserInfo',
  'intlTelInputOptions',
  '$window',
  '$location',
  '$resource',
  'Router',
  'moment',
  ($rootScope,
   $localStorage,
   $state,
   AuthService,
   AccountsService,
   $transitions,
   PermPermissionStore,
   ipUserInfo,
   intlTelInputOptions,
   $window,
   $location,
   $resource,
   Router,
   moment
  ) => {
    if (!$localStorage.settings) { $localStorage.settings = {theme: 'light'}; }
    $rootScope.settings = $localStorage.settings;
    AccountsService.setLast();
    AuthService.addAuthTokenToTheHttpHeaders();
    $rootScope.$on("UNAUTHORIZED", () => AuthService.logout());

    $transitions.onError({}, (transition) => {
      const error = transition.error();
      if (error.type === "AUTH_REQUIRED" || error.status === 401) {
        if ($location.path().startsWith('/integrations/init/livechat')) {
          const lcAccessToken = String($location.search()["token"]);
          AuthService.onAuthRequired($window.location.href, 'lcAccessToken', lcAccessToken, '/authorize/livechat');
        } else {
          AuthService.onAuthRequired($window.location.href);
        }
      }

      if (error) { $state.go(error.redirectTo, error.params); }
    });

    ipUserInfo.getIpInfo().then(() => intlTelInputOptions.initialCountry = ipUserInfo.getCountry());

    moment.updateLocale('en', {
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: '%d second',
        ss: '%d seconds',
        m: '%d minute',
        mm: '%d minutes',
        h: '%d hour',
        hh: '%d hours',
        d: '%d day',
        dd: '%d days',
        M: '%d month',
        MM: '%d months',
        y: '%d year',
        yy: '%d years'
      }
    });

    moment.updateLocale('es', {
      relativeTime: {
        future: 'en %s',
        past: 'hace %s',
        s: '%d segundos',
        ss: '%d segundos',
        m: '%d minuto',
        mm: '%d minutos',
        h: '%d hora',
        hh: '%d horas',
        d: '%d día',
        dd: '%d días',
        M: '%d mes',
        MM: '%d meses',
        y: '%d año',
        yy: '%d años'
      }
    });
  }];
